// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"db171629","239":"4ce7915d","453":"588c3456","732":"5f832ec7"}[chunkId] + ".chunk.js";
};